<ion-menu side="start" menuId="first" contentId="main" type="overlay" [swipeGesture]="loggedIn">
  <ion-header>
    <img src="/assets/img/Ishavskraftlogo.svg" class="ihk-logo-img" />
  </ion-header>
  <ion-content class="ion-padding-start sidemeny-content">
    <ion-item lines="none">
      <p class="valgt-bruker-p" *ngIf="kundeIdFromKC; else loadingTemplate">
        Valgt bruker:<br />
        {{getUserFromKundeId(kundeIdFromKC)}}
      </p>
      <ng-template #skel> </ng-template>
    </ion-item>
    <ion-list mode="md" lines="none">
      <ion-item class="pointer mimic_tab_button" [routerLink]="analyseRoute">
        <div class="mimic_ion_icon" slot="start">
          <app-tab-analyse-icon></app-tab-analyse-icon>
        </div>
        <p>Din analyse</p>
      </ion-item>
      <ion-item class="pointer onlyDisplayOnMobile mimic_tab_button" [routerLink]="nyttigRoute">
        <div class="mimic_ion_icon" slot="start">
          <app-tab-nyttig-icon></app-tab-nyttig-icon>
        </div>
        <p>Nytt og nyttig</p>
      </ion-item>
      <ion-item *ngIf="showEnodeInMenu" [routerLink]="avtaleRoute" class="pointer mimic_tab_button">
        <div class="mimic_ion_icon" slot="start">
          <app-tab-avtale-icon></app-tab-avtale-icon>
        </div>
        <p>Avtaler</p>
      </ion-item>
      <ion-item class="pointer onlyDisplayOnMobile mimic_tab_button" [routerLink]="profilRoute">
        <div class="mimic_ion_icon" slot="start">
          <app-tab-profile-icon></app-tab-profile-icon>
        </div>
        <p>Profil</p>
      </ion-item>
      <ion-item class="pointer mimic_tab_button" (click)="openBrukerKunde()">
        <div class="mimic_ion_icon" slot="start">
          <app-tab-brukerkunde-icon></app-tab-brukerkunde-icon>
        </div>
        <p>Kundetilganger</p>
      </ion-item>
      <ion-item class="pointer mimic_tab_button" (click)="openContactUs()">
        <div class="mimic_ion_icon" slot="start">
          <app-tab-contact-icon></app-tab-contact-icon>
        </div>
        <p>Kontakt oss</p>
      </ion-item>
      <ion-modal #contactUsModal [isOpen]="showContactUs" cssClass="contact-us-modal-content" backdropDismiss
        (didDismiss)="showContactUs = false">
        <ng-template>
          <app-contact-us-modal></app-contact-us-modal>
        </ng-template>
      </ion-modal>
      <ion-item *ngIf="!showEnodeInMenu" class="pointer mimic_tab_button" [routerLink]="enodeRoute">
        <div class="mimic_ion_icon" slot="start">
          <app-tab-enode-icon></app-tab-enode-icon>
        </div>
        <p class="">Smartlading</p>
      </ion-item>
    </ion-list>

    <app-logout></app-logout>


    <div class="versiontext" *ngIf="!isBrowser && appVersion">
      <p>
        Versjon {{appVersion}}
        <!-- .1 -->
      </p>
      <p *ngIf="isIos">
        <a href="https://apps.apple.com/us/app/ishavskraft/id1528706031">Se etter oppdateringer</a>
      </p>
      <p *ngIf="isAndroid">
        <a href="https://play.google.com/store/apps/details?id=no.Ishavskraft.Ishavskraft">Se etter oppdateringer</a>
      </p>
    </div>
  </ion-content>
</ion-menu>

<ion-router-outlet id="main"></ion-router-outlet>

<ion-tabs class="tabsmenu">
  <ion-tab-bar slot="bottom" class="tab_button1 tabsmenu" *ngIf="loggedIn">
    <ion-tab-button (click)="showHideMenu()">
      <app-tab-mer-icon></app-tab-mer-icon>
      <ion-label>Mer</ion-label>
    </ion-tab-button>
    <ion-tab-button *ngIf="isUserEier && isBrowser" href="https://minside.ishavskraft.no/admin">
      <ion-icon name="people-circle-outline" style="font-size: 30px"></ion-icon>
      <ion-label>Admin</ion-label>
    </ion-tab-button>

    <ion-tab-button [tab]="forbrukTab" [class.tab-selected]="selectedPath === forbrukTab">
      <app-tab-forbruk-icon></app-tab-forbruk-icon>
      <ion-label>Forbruk</ion-label>
    </ion-tab-button>

    <ion-tab-button *ngIf="showEnodeInMenu" [tab]="enodeTab" [class.tab-selected]="selectedPath === enodeTab">
      <app-tab-enode-icon></app-tab-enode-icon>
      <ion-label>Smartlading</ion-label>
    </ion-tab-button>

    <ion-tab-button [tab]="regningTab" [class.tab-selected]="selectedPath === regningTab">
      <app-tab-regning-icon></app-tab-regning-icon>
      <ion-label>Regninger</ion-label>
    </ion-tab-button>

    <ion-tab-button *ngIf="!showEnodeInMenu" [tab]="avtaleTab" [class.tab-selected]="selectedPath === avtaleTab">
      <app-tab-avtale-icon></app-tab-avtale-icon>
      <ion-label>Avtaler</ion-label>
    </ion-tab-button>

    <ion-tab-button [tab]="spotRoute" [class.tab-selected]="selectedPath === spotRoute">
      <app-tab-spot-icon></app-tab-spot-icon>
      <ion-label>Spot</ion-label>
    </ion-tab-button>

    <ion-tab-button [tab]="profilTab" [class.tab-selected]="selectedPath === profilTab" class="onlyDisplayOnDesktop">
      <app-tab-profile-icon></app-tab-profile-icon>
      <ion-label>Profil</ion-label>
    </ion-tab-button>

    <ion-tab-button [tab]="nyttigTab" [class.tab-selected]="selectedPath === nyttigTab" class="onlyDisplayOnDesktop">
      <app-tab-nyttig-icon></app-tab-nyttig-icon>
      <ion-label>Nyttig</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>

<ng-template #loadingTemplate>
  <div class="loadingContainer">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>